export const SET_SEARCH_TAB_INDEX = 'app/SET_TAB_PARAMS'
export const VERIFY_USER_LOGGED = 'app/VERIFY_USER_LOGGED'
export const TOGGLE_SHOW_INFO_CONTACT = 'app/TOGGLE_SHOW_INFO_CONTACT'
export const VERIFY_USER_NOT_LOGGED = 'app/VERIFY_USER_NOT_LOGGED'
export const SET_ACTIVE_ROLE = 'app/SET_ACTIVE_ROLE'
export const SET_ADMINISTRATOR_ACCOUNT = 'app/SET_ADMINISTRATOR_ACCOUNT'
export const VERIFY_USER_ROLE = 'app/VERIFY_USER_ROLE'
export const ADD_USER_ROLE = 'app/ADD_USER_ROLE'
export const TRY_INSCRIPTION_REGISTER = 'app/TRY_INSCRIPTION_REGISTER'
